// Isotopes of the possible generator types
// Only used for selection of generator type when creating a generator
export enum GeneratorTypeIsotope {

	GERMANIUM_68_GE = 'GERMANIUM_68_GE',

	MOLYBDENUM_99_MO = 'MOLYBDENUM_99_MO'
}
